import React, { useEffect, useRef, useState } from "react";
import Modal from 'react-bootstrap/Modal';

import {
    motion,
    useAnimation,
    useInView,
} from "framer-motion";
import { Link } from "react-router-dom";
import "./wedo.scss";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

/* ---------- animation variants ---------- */
const cardVariants = {
    hidden: { opacity: 1, y: 0 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: {
            delay: i * 0.2,
            duration: 0,

        },
    }),
};

const headerVariants = {
    hidden: { opacity: 0, y: -40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.8 },
    },
};

/* ---------- small helper component ---------- */
const AnimatedCard = ({ card, index }) => {
    const controls = useAnimation();
    const ref = useRef(null);
    const isInView = useInView(ref, { amount: 0.3, once: false });

    // when card enters / leaves viewport
    useEffect(() => {
        if (isInView) {
            controls.start("visible");
        } else {
            controls.start("hidden");
        }
    }, [isInView, controls]);

    return (
        <Link to={card.link} className="cards_link_wrapper">
            <motion.div
                ref={ref}
                className="cards_one"
                custom={index}
                variants={cardVariants}
                initial="hidden"
                animate={controls}
            >
                <img src={card.img} alt={card.title} />
                <h3>{card.title}</h3>
                <h4>{card.desc}</h4>
                <button className="animated-btn">
                    Learn More
                    {/* SVG kept short for brevity */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M13.8537 8.35403L9.35375 12.854C9.25993 12.9478 9.13268 13.0006 9 13.0006C8.86732 13.0006 8.74007 12.9478 8.64625 12.854C8.55243 12.7602 8.49972 12.633 8.49972 12.5003C8.49972 12.3676 8.55243 12.2403 8.64625 12.1465L12.2931 8.50028L2.5 8.50028C2.36739 8.50028 2.24021 8.4476 2.14645 8.35383C2.05268 8.26006 2 8.13289 2 8.00028C2 7.86767 2.05268 7.74049 2.14645 7.64672C2.24021 7.55296 2.36739 7.50028 2.5 7.50028L12.2931 7.50028L8.64625 3.85403C8.55243 3.76021 8.49972 3.63296 8.49972 3.50028C8.49972 3.3676 8.55243 3.24035 8.64625 3.14653C8.74007 3.05271 8.86732 3 9 3C9.13268 3 9.25993 3.05271 9.35375 3.14653L13.8537 7.64653C13.9002 7.69296 13.9371 7.74811 13.9623 7.80881C13.9874 7.86951 14.0004 7.93457 14.0004 8.00028C14.0004 8.06599 13.9874 8.13105 13.9623 8.19175C13.9371 8.25245 13.9002 8.30759 13.8537 8.35403Z" fill="#1126E1" />
                    </svg>
                </button>
            </motion.div>
        </Link>
    );
};

const Wedo = () => {


    const options = {
        margin: window.innerWidth > 600 ? 20 : 10,
        loop: true,
        autoplay: window.innerWidth > 600 ? true : false,
        autoplayTimeout: window.innerWidth > 600 ? 2000 : null,
        autoplayHoverPause: window.innerWidth > 600 ? true : false,
        smartSpeed: 600,
        autoplaySpeed: 600,
        nav: true,
        dots: false,
        navText: [
            "<img src='/assets/left.svg'/>",
            "<img src='/assets/right.svg'/>",
        ],
        responsive: {
            0: { items: 1 },
            300: { items: 1.1 },
            400: { items: 1.1 },
            600: { items: 1.1 },
            1000: { items: 2.5 },
            1300: { items: 3.5 },
            1700: { items: 4.5 },
        },
    };


    /* header animation controls */
    const headerCtrl = useAnimation();
    const headerRef = useRef(null);
    const headerInView = useInView(headerRef, { amount: 0.3, once: false });

    useEffect(() => {
        if (headerInView) headerCtrl.start("visible");
        else headerCtrl.start("hidden");
    }, [headerInView, headerCtrl]);

    /* data */
    const services = [
        {
            img: "/assets/one.svg",
            title: "Compliance & Governance",
            desc:
                "Stay Ahead of Compliance Risks and Secure Your Data with Our Expert Services!",
            link: "/compliance-governance",
        },
        {
            img: "/assets/two.svg",
            title: "Managed IT Services",
            desc:
                "Unlock Seamless IT Excellence with Our Managed Services!",
            link: "/managed-it-services",
        },
        {
            img: "/assets/three.svg",
            title: "Security Assessment",
            desc:
                "Fortify Your Defenses with Expert Security Assessments!",
            link: "/security-assessments",
        },
        {
            img: "/assets/four.svg",
            title: "Business Process Automation",
            desc:
                "Automatically creates and organizes tasks in Microsoft Planner based on Teams messages!",
            link: "/business-process-automation",
        },

        {
            img: "/assets/one.svg",
            title: "Accountant on Demand",
            desc:
                "Reliable Accounting Support, When You Need It Most We provide professional, fully remote accounting services tailored to your business.Accurate financial records, timely reporting, and full compliance with local & international standards so you can focus on growth while we handle the numbers.",
            link: "/accountant-on-demand",
        },

    ];

    return (
        <>

            <section className="we_do_main" id="whatwedo">
                <div className="custom-container1">
                    {/* ---------- section header ---------- */}
                    <motion.div
                        ref={headerRef}
                        className="top_we_DO"
                        variants={headerVariants}
                        initial="hidden"
                        animate={headerCtrl}
                    >
                        <div className="inner_we_do">
                            <h2>What We Do</h2>
                            <p>
                                Trust us to deliver unmatched reliability, security, and
                                forward‑thinking strategies for a future‑proof business.
                            </p>
                        </div>

                        {/* <button>
                        Learn More About Our Services
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M13.8537 8.35403L9.35375 12.854C9.25993 12.9478 9.13268 13.0006 9 13.0006C8.86732 13.0006 8.74007 12.9478 8.64625 12.854C8.55243 12.7602 8.49972 12.633 8.49972 12.5003C8.49972 12.3676 8.55243 12.2403 8.64625 12.1465L12.2931 8.50028L2.5 8.50028C2.36739 8.50028 2.24021 8.4476 2.14645 8.35383C2.05268 8.26006 2 8.13289 2 8.00028C2 7.86767 2.05268 7.74049 2.14645 7.64672C2.24021 7.55296 2.36739 7.50028 2.5 7.50028L12.2931 7.50028L8.64625 3.85403C8.55243 3.76021 8.49972 3.63296 8.49972 3.50028C8.49972 3.3676 8.55243 3.24035 8.64625 3.14653C8.74007 3.05271 8.86732 3 9 3C9.13268 3 9.25993 3.05271 9.35375 3.14653L13.8537 7.64653C13.9002 7.69296 13.9371 7.74811 13.9623 7.80881C13.9874 7.86951 14.0004 7.93457 14.0004 8.00028C14.0004 8.06599 13.9874 8.13105 13.9623 8.19175C13.9371 8.25245 13.9002 8.30759 13.8537 8.35403Z" fill="#180047" />
                        </svg>

                    </button> */}
                    </motion.div>

                    {/* ---------- cards ---------- */}
                    <div className="cards_Parrent">
                        <OwlCarousel className="owl-theme" {...options}>
                        {services.map((card, i) => (
                            <AnimatedCard key={card.title} card={card} index={i} />
                        ))}
                        </OwlCarousel>
                    </div>
                </div>
            </section>

        </>
    );
};

export default Wedo;